import { pyExternalError } from "@Sk";
import * as windowRpc from "./windowRpc";


let batchingStdout = "";
let lastOut: number | null;
const TIMEOUT = 100;

const sendStdout = (text: string) =>
    windowRpc.raiseEvent("consoleOutput", {fn: "stdout", text});

let outputTimeout: undefined | number = undefined;
const flushOutput = (out: string, when: number | null = null) => {
    clearTimeout(outputTimeout);
    sendStdout(batchingStdout);
    batchingStdout = "";
    lastOut = when;
};

const flushBatched = () => batchingStdout && flushOutput(batchingStdout, null);

export const stdout = (out: string, fromServer?: boolean) => {
    const now = Date.now();
    if (!lastOut) {
        // always print the first entry
        batchingStdout += out;
        flushOutput(out, now);
        return;
    }
    if (now - lastOut > TIMEOUT) {
        // we could be stuck in a loop
        // output batched and then start a new batch
        batchingStdout += out;
        flushOutput(batchingStdout, now);
    }
    clearTimeout(outputTimeout);
    batchingStdout += out;
    out = batchingStdout;
    outputTimeout = window.setTimeout(() => flushOutput(out, null), TIMEOUT / 4);
};


function _isExternalError(err: any): err is pyExternalError {
    return err.nativeError != null;
}

window.onerror = (
    errormsg?: string | null | Event,
    jsUrl?: string | null,
    jsLine?: number | null,
    jsCol?: number | null,
    errorObj?: Error
) => {
    if (batchingStdout) { flushOutput(batchingStdout); }


    if (errorObj instanceof Sk.builtin.BaseException) {
        windowRpc.raiseEvent("consoleOutput", windowRpc.errorForRpc(errorObj));
    } else {
        console.error("[Internal error]:", errorObj);
        windowRpc.raiseEvent("consoleOutput", {
            fn: "runtimeError",
            error: "" + (errorObj || "Unknown error"),
            msg: errormsg ? "" + errormsg : undefined,
            url: jsUrl,
            line: jsLine,
            col: jsCol,
            stackTrace: errorObj?.stack,
        });
    }
}
